
import io from 'socket.io-client';
export const appConstantsSocket = {    
    socket:io(process.env.REACT_APP_DOMAIN),
    paAppURL:process.env.REACT_APP_DOMAIN,
    s3UploadUrl:process.env.REACT_APP_SERVER_IMAGE_BUCKET,
}; 

export const appConstants = {    
    WEB_SERVICE_URL:process.env.REACT_APP_DOMAIN,
};

let  url = window.location.protocol+"//"+window.location.hostname+"/";
if(window.location.hostname==="localhost"){
	url=window.location.protocol+"//"+window.location.hostname+":3000/";
}

/*Local Stageing Bhaskar Production*/
// export const clienID = '81b9td9db2buf5';
// export const secretKey = 'wOVAL9IfPCIR06Yr';

/*Live Production*/
// export const clienID = '81skclgwzl5989';
// export const secretKey = 'YY4egsQ6qCpjnRkp';

// Right-Connection
// export const clienID = '86q9rkjvtgobjb';
// export const secretKey = 'm4xhKcbfEwxoiUnh';
// 12/10/2023
export const clienID = '86mese3vuxq7zk';
export const secretKey = '5SCInOF6A0t1aIxd';

/* Callback url for Linkedin */
export const callBackUrl = url+`linkedin`; 

/* Backend route for getting Linkedin Access Token */
export const accessTokenRoute = process.env.REACT_APP_DOMAIN+`/linkedinaccesstoken`;

/* Backend route for getting Linkedin User Details */
export const userDetailsRoute = process.env.REACT_APP_DOMAIN+`/linkedinuserdetails`;


export const  TableOption= {
    page: 1,  
    sizePerPage: 10,  
    pageStartIndex: 1,
    paginationSize: 3,  
    prePage: 'Prev', 
    nextPage: 'Next',
    firstPage: 'First', 
    lastPage: 'Last', 
    paginationShowsTotal: true, 
    paginationPosition: 'bottom',  
    alwaysShowAllBtns: true 
} ;

export const  message = {
    fieldSelect: "Please select field",  
    sendResumeWithoutSignin:"Please signup or login to continue.", 
    pageStartIndex: 1,
    paginationSize: 3,  
    prePage: 'Prev', 
    nextPage: 'Next', 
    firstPage: 'First',
    lastPage: 'Last', 
    paginationShowsTotal: true,  
    paginationPosition: 'bottom',  
    alwaysShowAllBtns: true
};


export const RULESMESSAGE = {
    required:"This field is required!",
    alpha:'First name should not contain a space or number!',
    email:'Please enter a valid Email address!',
};

export const cityForRedirectUrl = 	[
	{"cityName" : "New York","coordinates" : [ 40.7127753, -74.0059728]},

	{"cityName" : "Seattle", "coordinates" : [47.6062095, -122.3320708]},

	{"cityName" : "San Francisco","coordinates":[37.7749295, -122.4194155]},

	{"cityName" : "Los Angeles","coordinates" : [34.0522342, -118.2436849]},

	{"cityName" : "San Diego","coordinates" : [32.715738, -117.1610838]}
];

export const employementType = 	[
	{"label" : "Full-time","value" :"Full-time"},
	{"label" : "Part-time","value" :"Part-time"},
	{"label" : "Apprentice","value" :"Apprentice"},
	{"label" : "Trainee","value" :"Trainee"},
	{"label" : "Probation","value" :"Probation"},
	{"label" : "Shiftworkers","value" :"Shiftworkers"}
];

export const areaCode = 	[

	{"label" : "+1","value" :"+1"}
]

export const experienceArr = 	[
	{"label" : "1","value" :"1"},
	{"label" : "2","value" :"2"},
	{"label" : "3","value" :"3"},
	{"label" : "4","value" :"4"},
	{"label" : "5","value" :"5"},
	{"label" : "6","value" :"6"},
	{"label" : "7","value" :"7"},
	{"label" : "8","value" :"8"},
	{"label" : "9","value" :"9"},
	{"label" : "10","value" :"10"},
	{"label" : "11","value" :"11"},
	{"label" : "12","value" :"12"},
	{"label" : "13","value" :"13"},
	{"label" : "14","value" :"14"},
	{"label" : "15","value" :"15"},
	{"label" : "16","value" :"16"},
	{"label" : "17","value" :"17"},
	{"label" : "18","value" :"18"},
	{"label" : "19","value" :"19"},
	{"label" : "20","value" :"20"},
	{"label" : "21","value" :"21"},
	{"label" : "22","value" :"22"},
	{"label" : "23","value" :"23"},
	{"label" : "24","value" :"24"},
	{"label" : "25","value" :"25"},
	{"label" : "26","value" :"26"},
	{"label" : "27","value" :"27"},
	{"label" : "28","value" :"28"},
	{"label" : "29","value" :"29"},
	{"label" : "30","value" :"30"}
];


//DATEFORMATNOTTIME: "MMM DD, YYYY";


// WEBPACK FOOTER //
// ./src/_constants/app.constants.js